import type { TabsConfig } from '#types/config/components/vf/tabs'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    primary: {
      triggerContainer: 'mb-0.5 b-b b-grey-50 min-w-full i-flex',
      trigger: 'title-5 pb-3 pt-1 b-b-4 b-transparent ws-nowrap -mb-0.5',
      triggerActive: 'b-grey-10'
    }
  }
} satisfies RecursivePartial<TabsConfig>
